import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// HTTP client
import axios from 'axios';

// sweetalert2
import Swal from 'sweetalert2'
import $ from 'jquery';

// Bootstrap Components
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';

// RSuite Components (Grouped for readability)
import {
    VStack, HStack, Input, SelectPicker, Table, Pagination,
    Button, ButtonToolbar, IconButton,
    Modal, Panel, Tooltip, Whisper, Loader
} from 'rsuite';

// Thai Date Picker
import { ThaiDatePicker } from 'thaidatepicker-react';

export default class CareerPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            year: '',
            loading: false,
            modal: null,
            careerData: [],
            careerSortColumn: '',
            careerSortType: '',
            careerLimit: 10,
            careerPage: 1,
            activity_type: '',
            position: '',
            department: '',
            company_name: '',
            company_address: '',
            start_date: '',
            end_date: '',
            job_details: ''
        };
    }

    async componentDidMount() {
        const logged = JSON.parse(localStorage.getItem('logged') || '{}');
        const token = logged?.user?.token;

        if (!token) {
            return (window.location.href = '/login');
        }

        const authHeader = {
            headers: { Authorization: `Bearer ${token}` }
        };

        await this.promisedSetState({ authHeader });

        try {
            await this.onRenderContent({ mode: 'read' });
        } catch (error) {
            if (error.response?.status === 401) {
                window.location.href = '/login';
            } else {
                // จัดการ error อื่น ๆ ตามปกติ
                Swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
            }
        }
    }

    // Promise-based setState
    promisedSetState = (newState) => new Promise(resolve =>
        this.setState(newState, resolve)
    );

    handleDateChange = (value) => {
        this.setState({ date_start: value });
    };

    getCareerPaginatedData = () => {
        if (!this.state.careerData) return [];

        const { careerSortColumn, careerSortType, careerLimit, careerPage } = this.state;

        let data = [...this.state.careerData];

        if (careerSortColumn && careerSortType) {
            data.sort((a, b) => {
                let x = a[careerSortColumn];
                let y = b[careerSortColumn];

                if (typeof x === 'string' && typeof y === 'string') {
                    return careerSortType === 'asc' ? x.localeCompare(y) : y.localeCompare(x);
                }

                return careerSortType === 'asc' ? x - y : y - x;
            });
        }

        const start = careerLimit * (careerPage - 1);
        const end = start + careerLimit;

        return data.slice(start, end);
    };

    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            try {

                const { Column, HeaderCell, Cell } = Table;

                await this.promisedSetState({ loading: true })

                // ดึง ID ผู้ใช้จาก localStorage
                const id = JSON.parse(localStorage.getItem('logged') || '{}')?.user?.user?.id;

                if (!id) {
                    throw new Error("ไม่พบข้อมูลผู้ใช้ กรุณาเข้าสู่ระบบใหม่");
                }

                const careerRes = await axios.get(
                    `${process.env.REACT_APP_API}/career/applicant/${id}`,
                    this.state.authHeader
                );

                const careerApiData = careerRes.data;

                // ชื่อเดือนภาษาไทย
                const monthNamesThai = [
                    'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                    'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
                ];

                // ฟังก์ชันแปลงวันที่เป็น "1 กันยายน 66"
                function formatDateThaiShort(dateString) {
                    if (!dateString) return '';
                    const date = new Date(dateString);
                    if (isNaN(date)) return '';

                    const day = date.getDate();
                    const month = monthNamesThai[date.getMonth()];
                    const year = (date.getFullYear() + 543) % 100;

                    return `${day} ${month} ${year}`;
                }

                // แปลงข้อมูล API ให้เป็นข้อมูลที่แสดงผลได้ง่าย
                const mappedCareerData = (Array.isArray(careerApiData) ? careerApiData : [careerApiData]).map(item => ({
                    id: item.id,
                    start_date: formatDateThaiShort(item.start_date) || "-",
                    end_date: formatDateThaiShort(item.end_date) || "-",
                    department: item.department || "-",
                    company_name: item.company_name || "-",
                }));

                await this.promisedSetState({
                    careerData: mappedCareerData,
                });

                const paginatedData = this.getCareerPaginatedData();

                // Setting state using promisedSetState
                await this.promisedSetState({
                    content: <>
                        <Row className='mt-3'>
                            <Col>
                                <Breadcrumb size='lg' >
                                    <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                                    <Breadcrumb.Item active>ประวัติการศึกษา</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>

                        <Row className='mt-2'>
                            <Col lg={12} className='mb-3'>
                                <Panel
                                    header="ประวัติการทำงาน"
                                    className="shadow-sm"
                                    style={{ backgroundColor: '#FFF', padding: '0.5em', height: '100%' }}
                                >
                                    <Button
                                        className='mt-2'
                                        size='sm'
                                        startIcon={<i className="bi bi-plus-lg"></i>}
                                        color="green"
                                        appearance="primary"
                                        onClick={() => this.onModalWork({ mode: 'insert', id })} >
                                        เพิ่ม
                                    </Button>

                                    <Row className='mt-2'>
                                        <Col>
                                            <Table
                                                autoHeight
                                                data={paginatedData}
                                                bordered
                                                cellBordered
                                                className='shadow-sm'
                                            >
                                                <Column width={180} resizable>
                                                    <HeaderCell align="center">วันที่เริ่มงาน</HeaderCell>
                                                    <Cell align="center" dataKey="start_date" />
                                                </Column>

                                                <Column width={180} resizable>
                                                    <HeaderCell align="center">วันที่สิ้นสุด</HeaderCell>
                                                    <Cell align="center" dataKey="end_date" />
                                                </Column>

                                                <Column width={340} resizable>
                                                    <HeaderCell>ตำแหน่ง</HeaderCell>
                                                    <Cell dataKey="department" />
                                                </Column>

                                                <Column width={445} resizable>
                                                    <HeaderCell>ชื่อบริษัทหรือหน่วยงาน</HeaderCell>
                                                    <Cell dataKey="company_name" />
                                                </Column>
                                                <Column width={120} align="center" fixed="right">
                                                    <HeaderCell>...</HeaderCell>
                                                    <Cell style={{ padding: '6px' }}>
                                                        {rowData => (
                                                            <ButtonToolbar>
                                                                <Whisper followCursor speaker={<Tooltip>แก้ไข</Tooltip>}>
                                                                    <IconButton size='sm'
                                                                        color="yellow"
                                                                        appearance="primary"
                                                                        icon={<i className="bi bi-pencil-square"></i>}
                                                                        onClick={async () => {
                                                                            await this.promisedSetState({ changePassword: false, password: '', confirm_password: '' })
                                                                            await this.onModalWork({ mode: 'update', id: rowData.id })
                                                                        }}
                                                                    />
                                                                </Whisper>
                                                                <Whisper followCursor speaker={<Tooltip>ลบ</Tooltip>}>
                                                                    <IconButton size='sm'
                                                                        color="red"
                                                                        appearance="primary"
                                                                        icon={<i className="bi bi-trash-fill"></i>}
                                                                        onClick={() => this.onConfirm({ mode: 'delete', id: rowData.id })}
                                                                    />
                                                                </Whisper>
                                                            </ButtonToolbar>
                                                        )}
                                                    </Cell>
                                                </Column>
                                            </Table>

                                            <div style={{ padding: 20 }}>
                                                <Pagination
                                                    prev
                                                    next
                                                    first
                                                    last
                                                    ellipsis
                                                    boundaryLinks
                                                    maxButtons={5}
                                                    size="xs"
                                                    layout={['total', '|', 'pager']}
                                                    total={this.state.careerData ? this.state.careerData.length : 0}
                                                    limit={this.state.careerLimit}
                                                    activePage={this.state.careerPage}
                                                    onChangePage={async (e) => {
                                                        await this.promisedSetState({ careerPage: e }); // Update current page
                                                        await this.onRenderContent({ mode: 'read' }); // Fetch new data based on page
                                                    }}
                                                />
                                            </div>

                                        </Col>
                                    </Row>
                                </Panel>
                            </Col>
                        </Row>
                    </>
                })

                await this.promisedSetState({ loading: false })

            } catch (error) {
                // Handle errors here
                console.error('Error fetching data or rendering content:', error);

                // Redirect to Log In
                window.location.href = '/login';
            }
        }
    };

    onModalWork = async ({ mode, id, sel }) => {
        let data;

        if (!sel) {
            if (mode === 'update') {
                const response = await axios.get(`${process.env.REACT_APP_API}/career/${id}`, this.state.authHeader);
                const item = response.data;

                data = {
                    activity_type: item.activity_type || '',
                    position: item.position || '',
                    department: item.department || '',
                    company_name: item.company_name || '',
                    company_address: item.company_address || '',
                    start_date: item.start_date || '',
                    end_date: item.end_date || '',
                    job_details: item.job_details || ''
                };
            } else {
                // Default สำหรับ insert
                data = {
                    activity_type: '',
                    position: '',
                    department: '',
                    company_name: '',
                    company_address: '',
                    start_date: '',
                    end_date: '',
                    job_details: ''
                };
            }

            await this.promisedSetState(data);
        }

        await this.promisedSetState({
            modal: <Modal size={'md'}
                backdrop={'static'}
                keyboard={false}
                open={true}
                onClose={() => this.setState({ modal: null })}
            >
                <Modal.Header>
                    <Modal.Title>ข้อมูลประวัติการทำงาน</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Container>

                        <Row className='mb-3'>
                            <Col lg={6}>
                                <HStack>
                                    <label>ประเภทการทำงาน <span style={{ color: 'red' }}>*</span></label>
                                    <SelectPicker
                                        className='gT2xM'
                                        size='lg'
                                        data={[
                                            { value: 'งานประจำ', label: 'งานประจำ' },
                                            { value: 'งานพาร์ตไทม์', label: 'งานพาร์ตไทม์' },
                                            { value: 'ฟรีแลนซ์', label: 'ฟรีแลนซ์' },
                                            { value: 'ธุรกิจส่วนตัว', label: 'ธุรกิจส่วนตัว' },
                                        ]}
                                        defaultValue={this.state.activity_type}
                                        searchable={false}
                                        style={{ width: 180 }}
                                        placeholder="กรุณาเลือก"
                                        onChange={e => this.setState({ activity_type: e })}
                                        onClean={() => this.setState({ activity_type: '' })}
                                    />
                                </HStack>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={6} className='mb-3'>
                                <label>ตำแหน่ง <span style={{ color: 'red' }}>*</span></label>
                                <Input
                                    className='nP7cL'
                                    size='sm'
                                    defaultValue={this.state.position}
                                    onChange={e => this.setState({ position: e })} />
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <label>แผนก / ฝ่าย  <span style={{ color: 'red' }}>*</span></label>
                                <Input
                                    className='hR9vQ'
                                    size='sm'
                                    defaultValue={this.state.department}
                                    onChange={e => this.setState({ department: e })} />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={4} className='mb-3'>
                                <label>ชื่อบริษัทหรือหน่วยงาน  <span style={{ color: 'red' }}>*</span></label>
                                <Input
                                    className='xK4sW'
                                    size='sm'
                                    defaultValue={this.state.company_name}
                                    onChange={e => this.setState({ company_name: e })} />
                            </Col>
                            <Col lg={8} className='mb-3'>
                                <label>ที่อยู่บริษัท  <span style={{ color: 'red' }}>*</span></label>
                                <Input
                                    className='rJ3pZ'
                                    size='sm'
                                    defaultValue={this.state.company_address}
                                    onChange={e => this.setState({ company_address: e })} />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={4} className='mb-3'>
                                <VStack>
                                    <label>วันที่เริ่มงาน</label>
                                    <div className='mL8yB' style={{ display: 'flex', alignItems: 'center' }}>
                                        <ThaiDatePicker
                                            placeholder="วัน/เดือน/ปี พ.ศ."
                                            value={this.state.start_date}
                                            inputProps={{
                                                style: {
                                                    padding: '6px 8px',
                                                    borderRadius: '6px 0 0 6px',
                                                    border: '1px solid #E7E5E4',
                                                    width: '200px',
                                                }
                                            }}
                                            onChange={async (e) => {
                                                await this.promisedSetState({ start_date: e });
                                                await this.onModalWork({ mode, id, sel: true });
                                            }}
                                            onClean={async () => {
                                                await this.promisedSetState({ start_date: '' });
                                                await this.onModalWork({ mode, id, sel: true });
                                            }}
                                        />
                                        <IconButton
                                            icon={<i className="bi bi-calendar3"></i>}
                                            size="md"
                                            style={{
                                                borderRadius: '0 6px 6px 0', // top-left 0, top-right 6px, bottom-right 6px, bottom-left 0
                                            }}
                                        />
                                    </div>
                                </VStack>
                            </Col>
                            <Col lg={4} className='mb-3'>
                                <VStack>
                                    <label>วันที่สิ้นสุดงาน</label>
                                    <div className='zF6dC' style={{ display: 'flex', alignItems: 'center' }}>
                                        <ThaiDatePicker
                                            placeholder="วัน/เดือน/ปี พ.ศ."
                                            value={this.state.end_date}
                                            inputProps={{
                                                style: {
                                                    padding: '6px 8px',
                                                    borderRadius: '6px 0 0 6px',
                                                    border: '1px solid #E7E5E4',
                                                    width: '200px',
                                                }
                                            }}
                                            onChange={async (e) => {
                                                await this.promisedSetState({ end_date: e });
                                                await this.onModalWork({ mode, id, sel: true });
                                            }}
                                            onClean={async () => {
                                                await this.promisedSetState({ end_date: '' });
                                                await this.onModalWork({ mode, id, sel: true });
                                            }}
                                        />
                                        <IconButton
                                            icon={<i className="bi bi-calendar3"></i>}
                                            size="md"
                                            style={{
                                                borderRadius: '0 6px 6px 0', // top-left 0, top-right 6px, bottom-right 6px, bottom-left 0
                                            }}
                                        />
                                    </div>
                                </VStack>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col>
                                <label>รายละเอียดงาน <span style={{ color: 'red' }}>*</span></label>
                                <Input
                                    className='pN9aX'
                                    as="textarea"
                                    rows={3}
                                    defaultValue={this.state.job_details}
                                    onChange={e => this.setState({ job_details: e })}
                                />
                            </Col>
                        </Row>

                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button size='sm'
                        startIcon={<i className="bi bi-floppy-fill"></i>}
                        appearance="primary"
                        onClick={() => this.onConfirm({ mode, id })}>
                        บันทึก
                    </Button>
                    <Button size='sm'
                        appearance="subtle"
                        onClick={() => this.setState({ modal: null })}>
                        ยกเลิก
                    </Button>
                </Modal.Footer>
            </Modal>
        });
    }

    Validate = async (value, className, expected = '') => {
        try {
            // Trim ค่า string เพื่อกัน user ใส่ช่องว่างเปล่า
            const input = typeof value === 'string' ? value.trim() : value;

            // ตรวจสอบว่า className ถูกต้องหรือไม่
            if (!className || typeof className !== 'string') {
                console.warn(`Invalid className: "${className}"`);
                return false;
            }

            // เปรียบเทียบค่า input กับ expected
            const isValid = input !== expected;

            const $element = $('.' + className);
            if (!$element.length) {
                console.warn(`DOM element with class ".${className}" not found.`);
            }

            if (!isValid) {
                $element.addClass('required');

                await Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false;
            } else {
                $element.removeClass('required');
                return true;
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false;
        }
    };

    onConfirm = async ({ mode, id }) => {
        // --------------------- DELETE MODE ---------------------
        if (mode === 'delete') {
            Swal.fire({
                title: `คุณต้องการลบข้อมูลใช่หรือไม่?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `<div style="font-size: 1.2rem">ตกลง</div>`,
                cancelButtonText: `<div style="font-size: 1.2rem">ยกเลิก</div>`
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        this.setState({ loading: true });

                        const response = await axios.delete(
                            `${process.env.REACT_APP_API}/career/${id}`,
                            this.state.authHeader
                        );

                        const data = response.data;

                        if (data.message === 'successfully') {
                            Swal.fire({
                                title: "ลบข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            }).then(async () => {
                                await this.onRenderContent({ mode: 'read' });
                                this.setState({ modal: null });
                            });
                        } else {
                            Swal.fire({
                                title: "เกิดข้อผิดพลาดในการลบ",
                                text: data.message || 'ไม่สามารถลบข้อมูลได้',
                                icon: "error",
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                        }
                    } catch (error) {
                        if (error.response?.status === 401) {
                            window.location.href = '/login';
                        } else {
                            // จัดการ error อื่น ๆ ตามปกติ
                            Swal.fire({
                                title: 'เกิดข้อผิดพลาด',
                                text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                                icon: 'error',
                                confirmButtonText: 'ตกลง'
                            });
                        }
                    }
                }
            });

            this.setState({ loading: false });
            return;
        }

        // ฟังก์ชันตรวจสอบข้อมูลก่อนส่ง
        const validateInternship = async () => {
            const validationPromises = [
                this.Validate(this.state.activity_type, 'gT2xM', ''),
                this.Validate(this.state.position, 'nP7cL', ''),
                this.Validate(this.state.department, 'hR9vQ', ''),
                this.Validate(this.state.company_name, 'xK4sW', ''),
                this.Validate(this.state.company_address, 'rJ3pZ', ''),
                this.Validate(this.state.start_date, 'mL8yB', ''),
                this.Validate(this.state.job_details, 'pN9aX', ''),
            ];
            const results = await Promise.all(validationPromises);
            return results.every(result => result === true);
        };

        if (await validateInternship()) {
            try {
                this.setState({ loading: true });

                if (mode === 'insert') {
                    const response = await axios.post(
                        `${process.env.REACT_APP_API}/career`,
                        {
                            applicants_id: id,
                            activity_type: this.state.activity_type || '',
                            position: this.state.position || '',
                            department: this.state.department || '',
                            company_name: this.state.company_name || '',
                            company_address: this.state.company_address || '',
                            start_date: this.state.start_date || '',
                            end_date: this.state.end_date || '',
                            job_details: this.state.job_details || ''
                        },
                        this.state.authHeader
                    );

                    const data = response.data;

                    if (data.message === 'successfully') {
                        Swal.fire({
                            title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        }).then(async () => {
                            await this.promisedSetState({
                                activity_type: '',
                                position: '',
                                department: '',
                                company_name: '',
                                company_address: '',
                                start_date: '',
                                end_date: '',
                                job_details: ''
                            });
                            await this.onRenderContent({ mode: 'read' });
                            this.setState({ modal: null });
                        });
                    }
                } else if (mode === 'update') {
                    const response = await axios.patch(
                        `${process.env.REACT_APP_API}/career`,
                        {
                            id: id,  // ต้องมี id ของ record ที่จะอัปเดต
                            activity_type: this.state.activity_type || '',
                            position: this.state.position || '',
                            department: this.state.department || '',
                            company_name: this.state.company_name || '',
                            company_address: this.state.company_address || '',
                            start_date: this.state.start_date || '',
                            end_date: this.state.end_date || '',
                            job_details: this.state.job_details || ''
                        },
                        this.state.authHeader
                    );

                    const data = response.data;

                    if (data.message === 'successfully') {
                        Swal.fire({
                            title: "อัปเดตข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        }).then(async () => {
                            await this.promisedSetState({
                                edit_id: '',
                                activity_type: '',
                                position: '',
                                department: '',
                                company_name: '',
                                company_address: '',
                                start_date: '',
                                end_date: '',
                                job_details: ''
                            });
                            await this.onRenderContent({ mode: 'read' });
                            this.setState({ modal: null });
                        });
                    }

                }

                // ตัวอย่าง callback หลังบันทึกสำเร็จ (ถ้ามี)
                // await this.onSuccess({ mode: 'read' });

            } catch (error) {
                if (error.response?.status === 401) {
                    window.location.href = '/login';
                } else {
                    // จัดการ error อื่น ๆ ตามปกติ
                    Swal.fire({
                        title: 'เกิดข้อผิดพลาด',
                        text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    });
                }
            } finally {
                this.setState({ loading: false });
            }
        }
    };

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}